export const testIds = {
  startTrial: {
    successHeader: "trialSuccessHeader",
    successMessage: "trialSuccessMessage",
  },
}

export const zendeskWrapperId = "zendesk-wrapper"
export const laterButtonId = "later"
